import { howDoYouKnowUsValues } from '@asgard/api-common';
import { FormSelectOption } from 'components/form/FormSelect';
import { TFunction } from 'hooks/useI18n';
import { DEFAULT_TYPE_OPTION } from './Form.constants';

export const getTypeOptions = (t: TFunction): FormSelectOption[] => {
  const options = howDoYouKnowUsValues.map((h) => ({
    label: h,
    value: h
  }));

  return [DEFAULT_TYPE_OPTION, ...options].map((type) => ({
    ...type,
    label: t(`consultancy.form.how-do-you-know-us-values.${type.label}`)
  }));
};
